import React from 'react';
import FeedReaction from '../../../../SpecialMessage/messages/MessengerMessage/components/FeedReaction';
import FeedComment from '../../../../SpecialMessage/messages/MessengerMessage/components/FeedComment';
const MessengerPostback = ({ message }) => {
    return (React.createElement("div", null,
        message.feedComment && React.createElement(FeedComment, { feedComment: message.feedComment }),
        message.feedReaction && React.createElement(FeedReaction, { feedReaction: message.feedReaction })));
};
export default MessengerPostback;
